import { gql } from '@apollo/client';

export const SET_APPLIED_JOB_NOTES = gql`
  mutation SetAppliedJobNotes(
    $input: SetAppliedJobNotesInput!
    $locale: Locale
  ) {
    setAppliedJobNotes(input: $input) {
      ... on SetAppliedJobNotesSuccess {
        id
      }
      ... on SetAppliedJobNotesFailure {
        errors {
          message(locale: $locale)
        }
      }
    }
  }
`;
